import React, { useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import ConfirmModal from 'components/modal/ConfirmModal'
import { Delete as DeleteIcon } from '@mui/icons-material'
import { Box, Tooltip } from '@mui/material'
import { actionIconStyle } from 'components/ActionUtil'

const Delete = ({ onDelete = () => {} }) => {
    const [open, setOpen] = useState(false)

    const id = 'delete_action_navbar'

    return (
        <>
            <ConfirmModal
                isOpen={open}
                title={i18n.deletingConfirmation}
                onValidate={() => {
                    setOpen(false)
                    onDelete()
                }}
                onClose={() => setOpen(false)}
            />
            <Tooltip title={i18n.delete}>
                <Box sx={{ px: 2 }}>
                    <DeleteIcon
                        id={id}
                        data-cy={id}
                        onClick={() => setOpen(true)}
                        sx={{ ...actionIconStyle }}
                    />
                </Box>
            </Tooltip>
        </>
    )
}

Delete.propTypes = {
    onDelete: PropTypes.func.isRequired,
}

export default Delete